import { ChannelsModal } from "#features/channels/components/ChannelsModal.tsx";
import { SourcesModal } from "#features/conversations/components/sources-side-panel/SourcesModal.tsx";
import { useSidePanelStore } from "#stores/useSidePanelStore.ts";
import { useEffect } from "react";
import "./SidePanelAsModal.css";

export const SidePanelAsModal = () => {
    const sidePanelType = useSidePanelStore(state => state.type);
    const setIsModal = useSidePanelStore(state => state.setIsModal);

    // Buttons that open the panel announce a dialog only while it renders as one.
    useEffect(() => {
        setIsModal(true);

        return () => setIsModal(false);
    }, [setIsModal]);

    switch (sidePanelType) {
        case "sources":
            return <SourcesModal />;
        case "channels":
            return <ChannelsModal />;
        default:
            return null;
    }
};
